import styled from '@emotion/styled';
import {Text} from '@tempo/core';
import React from 'react';

const Wrapper = styled.div`
	position: fixed;
	display: none;

	@media (pointer: coarse) and (min-aspect-ratio: 1/1) {
		display: flex;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: #000;
		color: white;
		z-index: 1000;
		flex-direction: column;
		gap: 40px;
		align-items: center;
		justify-content: center;
	}
`;

const Phone = styled.div`
	@keyframes rotate {
		0% {
			transform: rotate(-90deg);
		}
		50% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(0deg);
		}
	}
	height: 100px;
	width: 100px;
	background-image: url('/images/phone.svg');
	background-repeat: no-repeat;
	background-position: center center;
	background-size: contain;
	position: relative;

	animation: rotate 2s cubic-bezier(0.65, 0, 0.35, 1) infinite alternate;
`;

const Arrow = styled.div`
	height: 30px;
	width: 30px;
	background-image: url('/images/curve-arrow.png');
	background-repeat: no-repeat;
	background-position: center center;
	background-size: contain;
	position: absolute;
	filter: invert(1);
`;

const ArrowLeft = styled(Arrow)`
	transform: rotate(90deg);
	top: -20px;
	left: -20px;
`;
const ArrowRight = styled(Arrow)`
	bottom: -20px;
	right: -20px;
	transform: rotate(-90deg);
`;

const ScreenRotate: React.FC = () => {
	return (
		<Wrapper>
			<Phone>
				<ArrowLeft />
				<ArrowRight />
			</Phone>
			<Text>Please rotate your device</Text>
		</Wrapper>
	);
};

export default ScreenRotate;
